// extracted by mini-css-extract-plugin
module.exports = {"root":"CommonControlButtons_root__1Bwgg"};